export enum ItemStatus {
  InStock = 'In Stock',
  Pending = 'Pending',
  CheckedOut = 'Checked Out',
  Shipped = 'Shipped',
}

export const itemStatuses = [ItemStatus.InStock, ItemStatus.Pending, ItemStatus.CheckedOut, ItemStatus.Shipped];
